module.exports = __webpack_public_path__ + "img/cs-calculator-frame.8cc346b0.png";